/**
 * A full-page navigation that leaves the single-page app (to the server's sign-in and sign-out
 * endpoints, or Microsoft Entra ID). One function, so tests can watch it.
 */
export function leaveTo(url: string): void {
  window.location.assign(url);
}
